import { render, staticRenderFns } from "./CsPagination.vue?vue&type=template&id=0d66c653&"
import script from "./CsPagination.vue?vue&type=script&setup=true&lang=ts&"
export * from "./CsPagination.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports